var React = require('react');

function YticonInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.7287 3.22717C19.1667 4.93492 19.1667 8.49992 19.1667 8.49992C19.1667 8.49992 19.1667 12.0649 18.7287 13.7727C18.4853 14.7166 17.7733 15.4593 16.8715 15.7104C15.2337 16.1666 9.58333 16.1666 9.58333 16.1666C9.58333 16.1666 3.93588 16.1666 2.29521 15.7104C1.38958 15.4555 0.6785 14.7138 0.437958 13.7727C2.85606e-08 12.0649 0 8.49992 0 8.49992C0 8.49992 2.85606e-08 4.93492 0.437958 3.22717C0.681375 2.28321 1.39342 1.5405 2.29521 1.28942C3.93588 0.833252 9.58333 0.833252 9.58333 0.833252C9.58333 0.833252 15.2337 0.833252 16.8715 1.28942C17.7771 1.54434 18.4882 2.28609 18.7287 3.22717ZM7.66667 11.8541L13.4167 8.49992L7.66667 5.14575V11.8541Z"}));
}

YticonInline.defaultProps = {"width":"20","height":"17","viewBox":"0 0 20 17"};

module.exports = YticonInline;

YticonInline.default = YticonInline;
